import ReviewForm from 'components/organisms/ReviewForm'
import * as React from 'react'
import { IReviewFormProps } from './new'

// 直接予約用レビュー
const ReviewNewForNonSignedIn: React.FC<IReviewFormProps> = props => {
  return <ReviewForm {...props} isDirectReservation={true} />
}
export default ReviewNewForNonSignedIn
